import { SxProps } from '@mui/material';

export const ParagraphStyles = (sx?: SxProps): SxProps => ({
  letterSpacing: 0.16,
  mb: 4,
  ...sx,
});
